import config from '../../config';

const transform = (suggestions) => suggestions.map((item) => ({ label: `${item.text}`, ...item }));

export const transformSuggestResponse = (resultVersion, query, response) => {
    if (resultVersion === 'result_v3') {
        return response;
    }

    if (query === '') {
        if (config.mobileSmartSuggest.config.suggestionsForEmptyQuery !== null) {
            return transform(response.topQueries);
        } else {
            return [];
        }
    }

    switch (config.mobileSmartSuggest.config.suggestType) {
        case 'suggest':
            return transform(response.textSuggestions);
        case 'suggestExtended':
            return transform(response.extendedTextSuggestions);
        default:
            throw new Error(`${config.mobileSmartSuggest.config.suggestType} is not a supported MSSO suggestion source.`);
    }
};
